import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-beta-help-content',
  templateUrl: './beta-help-content.component.html',
  styleUrls: ['./beta-help-content.component.scss']
})
export class BetaHelpContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
